"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contract = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var contractUtils_1 = require("../common/contractUtils");
var utils_1 = require("../common/utils");
var Contract = /** @class */ (function () {
    function Contract(stream, tokenId) {
        this.magic = 0;
        this.version = 0;
        this.createdAt = parseInt(stream.created);
        this.withdrawnAmount = new bn_js_1.default(stream.withdrawn);
        this.canceledAt = parseInt(stream.canceled_at);
        this.end = parseInt(stream.end);
        this.lastWithdrawnAt = parseInt(stream.last_withdrawn_at);
        this.sender = stream.sender;
        this.senderTokens = stream.sender;
        this.recipient = stream.recipient;
        this.recipientTokens = stream.recipient;
        this.mint = tokenId;
        this.escrowTokens = "";
        this.streamflowTreasury = "";
        this.streamflowTreasuryTokens = "";
        this.streamflowFeeTotal = new bn_js_1.default(0);
        this.streamflowFeeWithdrawn = new bn_js_1.default(0);
        this.streamflowFeePercent = parseInt(stream.fees.streamflow_fee_percentage) / 10000;
        this.partnerFeeTotal = new bn_js_1.default(0);
        this.partnerFeeWithdrawn = new bn_js_1.default(0);
        this.partnerFeePercent = 0;
        this.partner = "";
        this.partnerTokens = "";
        this.start = parseInt(stream.start);
        this.depositedAmount = new bn_js_1.default(stream.amount);
        this.period = parseInt(stream.period);
        this.amountPerPeriod = new bn_js_1.default(stream.amount_per_period);
        this.cliff = parseInt(stream.start);
        this.cliffAmount = new bn_js_1.default(stream.cliff_amount);
        this.cancelableBySender = stream.meta.cancelable_by_sender;
        this.cancelableByRecipient = stream.meta.cancelable_by_recipient;
        this.automaticWithdrawal = stream.meta.automatic_withdrawal;
        this.transferableBySender = stream.meta.transferable_by_sender;
        this.transferableByRecipient = stream.meta.transferable_by_recipient;
        this.canTopup = stream.meta.can_topup;
        var name = stream.meta.contract_name.replace("0x", "");
        this.name = Buffer.from(name, "hex").toString("utf8");
        this.withdrawalFrequency = parseInt(stream.meta.withdrawal_frequency);
        this.closed = stream.closed;
        this.currentPauseStart = parseInt(stream.current_pause_start);
        this.pauseCumulative = new bn_js_1.default(stream.pause_cumulative);
        this.lastRateChangeTime = parseInt(stream.last_rate_change_time);
        this.fundsUnlockedAtLastRateChange = new bn_js_1.default(stream.funds_unlocked_at_last_rate_change);
        this.type = (0, contractUtils_1.buildStreamType)(this);
    }
    Contract.prototype.unlocked = function (currentTimestamp) {
        return (0, contractUtils_1.calculateUnlockedAmount)(__assign(__assign({}, this), { currentTimestamp: currentTimestamp }));
    };
    Contract.prototype.remaining = function (decimals) {
        return (0, utils_1.getNumberFromBN)(this.depositedAmount.sub(this.withdrawnAmount), decimals);
    };
    return Contract;
}());
exports.Contract = Contract;
